'use client'

import { useTranslations } from 'next-intl'
import { Alert } from '@/app/[locale]/(ui)/alert'

export const ValidationAlert = ({ className }: { className?: string }) => {
  const t = useTranslations()

  return (
    <Alert variant="error" className={className}>
      {t('Form_missing_fields')}
    </Alert>
  )
}
